import React, { PropsWithChildren, useContext } from 'react';

import FocusLock from 'react-focus-lock';
import { Context } from '@front10/helpers/dist/Context';
import getStyles from '@front10/helpers/dist/UseStyles';

function Calendar({ children, ...rest }: PropsWithChildren<{}>) {
  const { direction, theme } = useContext(Context);
  const [className] = getStyles(rest, { direction, theme });
  return (
    <FocusLock returnFocus className={className}>
      {children}
    </FocusLock>
  );
}

export default Calendar;
